import { render, staticRenderFns } from "./maintenance-home.vue?vue&type=template&id=0faa2800&scoped=true&"
import script from "./maintenance-home.vue?vue&type=script&lang=js&"
export * from "./maintenance-home.vue?vue&type=script&lang=js&"
import style0 from "./maintenance-home.vue?vue&type=style&index=0&id=0faa2800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa2800",
  null
  
)

export default component.exports